// extracted by mini-css-extract-plugin
module.exports = {"container":"GetStartedChecklist_container__16DDM","text-container":"GetStartedChecklist_text-container__3pA4Y"};